module.exports = __webpack_public_path__ + "img/system-boss-img.c5f5bbd3.jpg";